import { Editor, Transforms, Node, Range } from 'slate';
import unified from 'unified';
import stringify from 'remark-stringify';
import parse from 'rehype-parse';
import rehype2remark from 'rehype-remark';
import { makeLineElement } from './element-factories';
export const insertPlainText = (editor, text) => {
    const selection = editor.selection;
    if (selection == null) {
        return;
    }
    const lines = text.split('\n');
    if (lines.length === 0) {
        return;
    }
    Editor.withoutNormalizing(editor, () => {
        const firstLineText = lines[0];
        if (lines.length === 1) {
            Editor.insertText(editor, firstLineText);
            return;
        }
        const [currentStart, currentEnd] = Range.edges(selection);
        const focusedTextNode = Node.get(editor, currentEnd.path);
        const rightText = focusedTextNode.text.slice(currentEnd.offset);
        if (rightText.length > 0) {
            editor.apply({
                type: 'remove_text',
                path: currentEnd.path,
                offset: currentEnd.offset,
                text: rightText,
            });
        }
        Editor.insertText(editor, firstLineText);
        const followingLines = lines.slice(1).map(makeLineElement);
        const insertPath = [currentStart.path[0], currentStart.path[1] + 1];
        Transforms.insertNodes(editor, followingLines, {
            at: insertPath,
        });
        const newFocus = Editor.end(editor, [
            currentStart.path[0],
            currentStart.path[1] + followingLines.length,
        ]);
        if (rightText.length > 0) {
            editor.apply({
                type: 'insert_text',
                path: newFocus.path,
                offset: newFocus.offset,
                text: rightText,
            });
        }
        Transforms.select(editor, newFocus);
    });
};
// NOTE: The original implementation adds a line break to the end of output and it is undesirable for this use.
// Then, here an original root visitor for remark-stringify is defined to avoid that behavior.
// Ref: https://github.com/remarkjs/remark/blob/master/packages/remark-stringify/lib/visitors/root.js
const root = function (node) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const doc = this.block(node);
    return doc;
};
const htmlProcessor = unified()
    .use(parse, { fragment: true })
    .use(rehype2remark)
    .use(stringify, {
    gfm: true,
    commonmark: true,
    listItemIndent: '1',
    fences: true,
})
    .use(function () {
    const Compiler = this.Compiler;
    const visitors = Compiler.prototype.visitors;
    visitors.root = root;
});
export const html2md = (html) => {
    const resultVfile = htmlProcessor.processSync(html);
    return String(resultVfile);
};
const insertHtml = (editor, html) => {
    // TODO: This can be more effective since mdast is already obtained during the conversion and it can be used to skip the normalization.
    insertPlainText(editor, html2md(html));
};
export const withMarkdownInsertData = (editor) => {
    const { insertData } = editor;
    editor.insertData = (data) => {
        if (data.types.includes('application/x-slate-fragment')) {
            insertData(data);
            return;
        }
        const html = data.getData('text/html');
        if (html) {
            insertHtml(editor, html);
            return;
        }
        const text = data.getData('text/plain');
        if (text) {
            insertPlainText(editor, text);
            return;
        }
        return insertData(data);
    };
    return editor;
};
//# sourceMappingURL=insertData.js.map